import React, {useEffect, useRef, useState} from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {htmlToJson} from "../../../common/utils/html-parser-util";
import _ from "lodash";

const RichTextEditor = ({
                            setContentLines,
                            existingContent = '',
                            readOnly = false,
                            currentInputText = undefined,
                            setCurrentInputText = undefined,
                        }) => {
    const [content, setContent] = useState("");
    const editorRef = useRef(null);

    useEffect(() => {
        if (existingContent) {
            // setContent(existingContent);

            let htmlContent = _.split(existingContent, '\n').join('</br>');
            editorRef.current?.getEditor()?.clipboard.dangerouslyPasteHTML(htmlContent);
        }
    }, [existingContent]);

    /*useEffect(() => {
        if (currentInputText) {
            setContent(currentInputText?.text);
            console.log('currentInputText?.text', currentInputText?.text);
        }
    }, [currentInputText]);*/

    const handleChange = (value) => {
        setContent(value);
        const jsonContent = htmlToJson(value);

        if (setContentLines) {
            setContentLines(jsonContent);
        }

        if (currentInputText && setCurrentInputText) {
            const existingCurrentInputText = {...currentInputText};
            existingCurrentInputText.text = value;
            setCurrentInputText(existingCurrentInputText);
        }
    };

    return (
        <ReactQuill
            ref={editorRef}
            readOnly={readOnly}
            value={content}
            onChange={handleChange}
            modules={RichTextEditor.modules}
            formats={RichTextEditor.formats}
        />
    );
};

RichTextEditor.modules = {
    toolbar: [
        [{header: "1"}, {header: "2"}, {font: []}],
        [{size: ["small", false, "large", "huge"]}],
        ["bold", "italic", "underline", "strike", "blockquote"],
        [
            {list: "ordered"},
            {list: "bullet"},
            {indent: "-1"},
            {indent: "+1"},
        ],
        ["link", "image", "video"],
    ],
    clipboard: {
        matchVisual: false,
    },
};

RichTextEditor.formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video"
];

export default RichTextEditor;
